import styled from 'styled-components';

import colors from '../../../styles/theme/colors';
import { radii } from '../styles/scales';
import { rgba } from '../styles/rgba';
import {
  buttonSizes,
  buttonTextSizes,
  buttonVariants,
  spin,
} from './constants';
import { ButtonSize, ButtonVariant } from './types';

const { green } = colors.designSystem;

export const StyledButton = styled.button<{
  variantType: ButtonVariant;
  sizeType: ButtonSize;
}>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  overflow: hidden;

  border-radius: ${radii.small};
  font-weight: 500;
  cursor: pointer;

  transition: color 150ms ease, background-color 150ms ease,
    border-color 150ms ease, box-shadow 150ms ease;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 2px ${rgba(green[500], 0.4)};
  }

  &:disabled {
    cursor: not-allowed;
  }

  ${({ variantType }) => buttonVariants[variantType]}
  ${({ variantType, sizeType }) =>
    variantType === 'link' ? buttonTextSizes[sizeType] : buttonSizes[sizeType]}
`;

export const LoadingSpinner = styled.span`
  width: 16px;
  height: 16px;
  border-radius: ${radii.full};
  border: 2px solid currentColor;
  border-top-color: transparent;
  animation: ${spin} 700ms linear infinite;
`;
